import "./App.css";
import Form from "./components/form1.js";
import ExplainText from "./components/explainText.js";
import LanguageSelection from "./components/languageSelection.js";
import ExamplePlayer from "./components/examplePlayer.js";
import React, { Suspense, useState, useContext } from "react";
import Store from "./components/Store2.js";
import { BrowserRouter as Router, Route } from "react-router-dom";

export default function App2() {
    return (
        <div>
            <Suspense fallback={<div>Loading...</div>}>
                <Store>
                    <Form />
                    <ExamplePlayer />
                    <LanguageSelection />
                    <ExplainText />
                </Store>
            </Suspense>
        </div>
    );
}
